import { render, staticRenderFns } from "./mealGoodsList.vue?vue&type=template&id=0ecc52d0"
import script from "./mealGoodsList.vue?vue&type=script&lang=ts"
export * from "./mealGoodsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports